export const status = {
  scheduled: 'Agendado',
  canceled: 'Cancelado',
  absent: 'Ausente',
  attended: 'Atendido',
  delayed: 'Atrasado',
  in_attendance: 'Em Atendimento'
}

export const getOptionsStatus = () => {
  return Object.keys(status).map((key) => {
    return {
      id: key,
      label: status[key]
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/resources/dataStatus.js